import { render, staticRenderFns } from "./AccessPointMonitor.vue?vue&type=template&id=242894db"
import script from "./AccessPointMonitor.vue?vue&type=script&lang=js"
export * from "./AccessPointMonitor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports